export var spotName = 'BTPG';
